/* Keep each marketing section menu below the site navigation and mark the reading position. */
(function () {
  'use strict';
  var page = document.querySelector('[data-nq-page]');
  var menu = page && page.querySelector('.nq-ops-sections');
  var main = document.getElementById('nqNav');
  if (!menu || !main) return;
  var links = Array.from(menu.querySelectorAll('a'));
  var sections = links.map(function (link) { return document.getElementById(link.hash.slice(1)); });
  var scroller = document.createElement('div');
  scroller.className = 'nq-ops-sections__scroller';
  links.forEach(function (link) { scroller.appendChild(link); });
  var prev = document.createElement('button');
  var next = document.createElement('button');
  prev.type = 'button';
  next.type = 'button';
  prev.className = 'nq-ops-sections__chev nq-ops-sections__chev--prev';
  next.className = 'nq-ops-sections__chev nq-ops-sections__chev--next';
  prev.setAttribute('aria-label', menu.getAttribute('data-prev-label') || '');
  next.setAttribute('aria-label', menu.getAttribute('data-next-label') || '');
  menu.appendChild(prev);
  menu.appendChild(scroller);
  menu.appendChild(next);

  var pending = false;
  var lastActive = -2;
  var marker = document.createElement('div');
  marker.setAttribute('aria-hidden', 'true');
  menu.before(marker);

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function narrowLayout() {
    return window.matchMedia('(max-width: 991px)').matches;
  }

  function centerActive(index) {
    if (!narrowLayout()) {
      scroller.style.paddingLeft = '';
      scroller.style.paddingRight = '';
      return;
    }
    var link = links[index];
    if (!link) return;
    var pad = Math.max(0, (scroller.clientWidth - link.offsetWidth) / 2);
    scroller.style.paddingLeft = pad + 'px';
    scroller.style.paddingRight = pad + 'px';
    var linkRect = link.getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();
    var delta = (linkRect.left + linkRect.width / 2) - (scrollerRect.left + scrollerRect.width / 2);
    var max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    var left = Math.min(max, Math.max(0, scroller.scrollLeft + delta));
    scroller.scrollTo({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' });
  }

  function syncEnds(index) {
    var overflow = narrowLayout() && scroller.scrollWidth > scroller.clientWidth + 2;
    menu.classList.toggle('nq-ops-sections--overflow', overflow);
    var fadeLeft = overflow && index > 0;
    var fadeRight = overflow && index < links.length - 1;
    menu.classList.toggle('nq-ops-sections--fade-left', fadeLeft);
    menu.classList.toggle('nq-ops-sections--fade-right', fadeRight);
    prev.classList.toggle('is-faded', !fadeLeft);
    next.classList.toggle('is-faded', !fadeRight);
    prev.disabled = !fadeLeft;
    next.disabled = !fadeRight;
  }

  function go(delta) {
    var current = links.findIndex(function (link) {
      return link.getAttribute('aria-current') === 'location';
    });
    var index = current < 0 ? (delta > 0 ? 0 : -1) : current + delta;
    var section = sections[index];
    if (!section) return;
    section.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    if (section.id) window.history.replaceState(null, '', '#' + section.id);
  }

  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });

  function update() {
    pending = false;
    page.style.setProperty('--nq-section-menu-height', menu.offsetHeight + 'px');
    var top = main.getBoundingClientRect().bottom + 8;
    var markerTop = marker.getBoundingClientRect().top;
    var docked = ['home', 'agencies', 'ops'].includes(page.dataset.nqPage) && markerTop > window.innerHeight - menu.offsetHeight;
    menu.classList.toggle('nq-ops-sections--bottom', docked);
    marker.style.height = docked ? menu.offsetHeight + 'px' : '';
    var offset = top + menu.offsetHeight + 16;
    menu.classList.toggle('nq-ops-sections--floating', !docked && markerTop <= top);
    page.style.setProperty('--nq-ops-menu-top', top + 'px');
    page.style.setProperty('--nq-ops-anchor-offset', offset + 'px');
    var active = -1;
    sections.forEach(function (section, index) {
      if (section && section.getBoundingClientRect().top <= offset + 24) active = index;
    });
    links.forEach(function (link, index) {
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    if (!narrowLayout()) {
      scroller.style.paddingLeft = '';
      scroller.style.paddingRight = '';
    }
    syncEnds(active);
    if (active !== lastActive) {
      lastActive = active;
      if (narrowLayout() && active >= 0) centerActive(active);
    }
  }

  function schedule() {
    if (!pending) { pending = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(schedule);
    observer.observe(main);
    observer.observe(menu);
  }
  update();
})();
